import { CustomersApi, VesselPropertiesApi, VesselsApi } from '@rhim/rest/customerManagement';
import { FeatureAssignmentsApi } from '@rhim/rest/customerManagement-v3';
import { Configuration } from '@rhim/rest/wearManagement';

const configuration: Configuration = {} as Configuration;

const BASE_URL = '/api/customermanagement/v2';

export const vessels = new VesselsApi(configuration, BASE_URL);
export const vesselProperties = new VesselPropertiesApi(configuration, BASE_URL);
export const customers = new CustomersApi(configuration, BASE_URL);

const BASE_URL_V3 = '/api/customermanagement/v3';
export const featureAssignments = new FeatureAssignmentsApi(configuration, BASE_URL_V3);
